import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';

export const fetchPeriodPrevGroupingData = createAsyncThunk(
    'user/fetchPeriodPrevGroupingData',
    async ({clientId, period, periodType}) => {
		try{
		
			const response = await fetchFun(`/api/periodGroupedData?clientId=${clientId}&period=${period}`);
			if(!response?.success){
				throw new Error("No grouping data found!")
			}
			return {periodType: periodType, result: response?.periodgroupedData};
		} catch (error) {
			console.log("Error - /periodGroupedData", error)
		}
    }
);